export const IN_APP_BACK_PRESSED = 'IN_APP_BACK_PRESSED'
export const RESET_IN_APP_BACK_PRESSED = 'RESET_IN_APP_BACK_PRESSED'


export interface SetInAppBackPressed {
  type: typeof IN_APP_BACK_PRESSED,
  payload: {}
}

export interface ResetInAppBackPressed {
  type: typeof RESET_IN_APP_BACK_PRESSED,
  payload: {}
}

export type AppBackAction =
  | SetInAppBackPressed
  | ResetInAppBackPressed;